<template>
    <div class="form-block">
        <div>
            <h2 class="form-block__title mb-3">{{prop_titleform}}</h2>
            <div class="black_block d-flex flex-column">
                <div
                    v-for="spoof_info in (add_person_report.spoofWarnings || [])"
                    :key="'spoof-' + spoof_info"
                    class="spoof-warning"
                >
                    {{spoof_info}}
                </div>
                <div v-for="bad_image_info in add_person_report.badImages" :key="bad_image_info">
                    {{bad_image_info}}
                </div>

                <div v-show="add_person_report.result">
                    {{add_person_report.result}}
                </div>
            </div>            
        </div>
        <div class="form-block__footer d-flex justify-content-between">
            <div class="form-block__footer_left d-flex justify-content-start align-items-end">                
            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">OK</button>                                
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from "axios";


export default {
    props: [
        'prop_titleform',
        'prop_add_person_report',
    ],
    data(){
        return{
            title_form: '',
            add_person_report: {}
        }
    },
    methods: {
        findname(){
            console.log('this.model_find', this.model_find);
            this.getCategoriesWithPersons();

        },       
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        
    },
    mounted(){
        this.title_form = this.prop_titleform;        
        this.add_person_report = this.prop_add_person_report;

        console.log('this.add_person_report 3 : ', this.add_person_report);
    },
    components: {        
    },
    computed: {        
    }
    
}
</script>

<style scoped lang="scss">
    .input_search {
        margin-bottom: 10px;
    }
    .categoryName{
        cursor: pointer;
    }    
    .black_block{
        height: 500px;
        overflow-y: scroll;
    }
    .spoof-warning{
        color: #c47a00;
        font-weight: 600;
        margin-bottom: 0.5rem;
    }
    .personMergeTo {        
        margin: 10px;
        input, label {
            cursor: pointer;
        }
    }
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
